/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

var store = {
  // Elements via data attributes
  selectors: {
    productObj: '[data-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    headerSlider: '[data-header-slider]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]'
  },

  // Global objects
  currentTemplate: null,
  isLoading: false,
  moneyFormat: window.theme.moneyFormat,
  colorSwatchesEnabled: window.theme.colorSwatchesEnabled,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,
  BundleProductDiscount1: window.theme.BundleProductDiscount1,
  BundleProductDiscount2: window.theme.BundleProductDiscount2,
  BundleProductDiscount3: window.theme.BundleProductDiscount3,
  freeShippingEnabled: window.theme.freeShippingEnabled,
  customerFirstName: '',
  customerLastName: '',
  customerEmail: '',
  customerPhoneNumber: '',
  customerPassword: '',
  confirmCustomerPassword: '',

  // service page form objects
  contactFormName: '',
  contactFormRut: '',
  contactFormEmail: '',
  contactFormPhone: '',
  contactFormMessage: '',
  contactFormCategory: '',
  contactFormModel: '',
  contactFormstate: '',
  contactFormCountry: '',
  contactFormAddress: '',
  contactFormOrderNo: '',
  contactFormWarranty: '',
  contactFormTermsofService: '',
  contactFormTechnicalVisit: '',
  contactFormBoughtProduct: '',
  selectedSwatchColor: '',
  selectedSwatchSize: '',
  selectedSwatchType: '',

  // order tracking page
  orderTrackingNumber: '',
  ticketTrackingNumber: '',
  grecapchaTrackingNumber: '',
  OrderTrackingDetails: {},

  recentlyAddedIdentifier: '',
  recentlyAddedQty: '',
  WarrantyTotalPrice: null,
  hasWarrantyProduct: false,
  isMobile: false,
  InstallationTotalPrice: null,
  GrillAssemblyTotalPrice: null,
  checkInstGrillTyp: [],

  backInStockerror: false,
  backInStockDone: false,

  // inventory location wise
  inventoryObj: [],
  selectedRegion: null,
  selectedComuna: null,
  // checkout 2.0
  // chck2DeliveryObj: [],
  // chck2DeliverySellerObj: [],
  // chck2PreorderObj: [],
  // chck2PickupObj: [],

  banner_1event: false,
  banner_2event: false,
  banner_3event: false,
  banner_4event: false,
  banner_5event: false,
  banner_6event: false,
  banner_7event: false,
  banner_8event: false,
  banner_9event: false,
  banner_10event: false,

  banner_new_event: []

};

export default store;